import { CogIcon, LogOutIcon, User, Bell } from "lucide-react";
import React, { useContext, useState, useEffect, useRef } from "react";
import { UserContext } from "../context/userContext";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const { handleLogout, user, toggleSidebar } = useContext(UserContext);

  const notifRef = useRef();
  const profileRef = useRef();

  const notifications = [
    { id: 1, text: "New staff registered", time: "2 min ago" },
    { id: 2, text: "Report submitted", time: "10 min ago" },
    { id: 3, text: "Student updated profile", time: "1 hour ago" }
  ];

  useEffect(() => {
    const handler = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md border-b border-gray-100 z-30">
      <div className="flex items-center justify-between px-6 py-3">
        
        {/* LEFT */}
        <div className="flex items-center gap-3">
          <button
            onClick={toggleSidebar}
            className="text-gray-600 hover:text-blue-500 transition-all cursor-pointer block"
          >
            <i className="ti ti-menu-2 text-2xl"></i>
          </button>

          <h1 className="text-lg font-semibold text-gray-700 tracking-wide">
            Dashboard
          </h1>
        </div>

        {/* CENTER */}
        <div className="hidden sm:flex items-center gap-3">
          <h1 className="text-lg font-semibold text-gray-700 tracking-wide">
            {user?.collegeId?.name}
          </h1>
        </div>

        {/* RIGHT */}
        <div className="flex items-center gap-6">

          {/* Notifications */}
          <div className="relative" ref={notifRef}>
            {/* <button
              onClick={() => setNotifOpen(!notifOpen)}
              className="relative text-gray-600 hover:text-blue-500 transition-all"
            >
              <Bell size={22} />
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
            </button> */}

            {notifOpen && (
              <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-100 rounded-lg shadow-xl p-2 max-h-64 overflow-y-auto">
                <h3 className="px-3 py-2 font-semibold text-gray-700 border-b">Notifications</h3>
                {notifications.map((n) => (
                  <div key={n.id} className="px-3 py-2 hover:bg-gray-50 rounded-md cursor-pointer">
                    <p className="text-sm text-gray-700">{n.text}</p>
                    <span className="text-xs text-gray-400">{n.time}</span>
                  </div>
                ))}
                {!notifications.length && (
                  <p className="text-center text-gray-500 py-3">No notifications</p>
                )}
              </div>
            )}
          </div>

          {/* Profile */}
          <div className="relative" ref={profileRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-2 bg-gradient-to-r from-blue-100 to-sky-50 px-3 py-1.5 rounded-full shadow-sm hover:shadow-md transition-all"
            >
              <img
                src={user?.profile || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                className="w-8 h-8 rounded-full"
              />
              <span className="font-medium text-gray-700 hidden sm:block">
                {user?.name || "Dean"}
              </span>
              <i
                className={`ti ti-chevron-down transition-transform ${
                  dropdownOpen ? "rotate-180" : ""
                }`}
              ></i>
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-100 rounded-lg shadow-xl">
                <ul className="text-gray-700 text-sm">
                  <li
                    className="flex items-center gap-2 px-4 py-2 hover:bg-sky-50 cursor-pointer text-blue-500 font-medium"
                    onClick={() => navigate("/profile")}
                  >
                    <User size={16} /> <span>Profile</span>
                  </li>

                  {/* <li
                    className="flex items-center gap-2 px-4 py-2 hover:bg-sky-50 cursor-pointer text-blue-500 font-medium"
                    onClick={() => navigate("/settings")}
                  >
                    <CogIcon size={16} /> <span>Setting</span>
                  </li> */}

                  <li
                    className="flex items-center gap-2 px-4 py-2 hover:bg-sky-50 cursor-pointer text-red-500 font-medium"
                    onClick={handleLogout}
                  >
                    <LogOutIcon size={16} /> <span>Logout</span>
                  </li>
                </ul>
              </div>
            )}
          </div>

        </div>
      </div>
    </header>
  );
}

export default Header;
